import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const getApkVersion = async () => axios.get(Routes.GET_APK_VERSION);

export const useGetApkVersion = () =>
  useQuery({
    queryKey: [Keys.APK_VERSION],
    queryFn: getApkVersion,
  });
